import React, { FC } from "react";

import { VariantType } from "@/styles/components/table/StyledTableCellText";
import { StyledTableCell, StyledTableCellText } from "@/styles/styled";

export type SingleLineCellProps = {
    variant?: VariantType;
    highlight?: boolean;
    testId?: string;
    children: React.ReactElement | string;
};
const SingleLineCell: FC<SingleLineCellProps> = ({ variant = "normal", highlight = false, testId, children }) => {
    return (
        <StyledTableCell data-testid={testId}>
            <StyledTableCellText $variant={variant} $highlight={highlight}>
                {children}
            </StyledTableCellText>
        </StyledTableCell>
    );
};

export default SingleLineCell;
